import React from 'react';
import { motion } from 'framer-motion';
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import PositionItem from './PositionItem';
import { Positions } from './careerData';
import './Careers.css';

const getAllCountries = () => {
  const countryCodes = getCountries();
  return countryCodes.map((code) => ({
    code,
    dial: `+${getCountryCallingCode(code)}`,
    name: new Intl.DisplayNames(["en"], { type: "region" }).of(code),
  }));
};

const allCountries = getAllCountries();
const dropCountries = ["US", "GB", "IN", "CA"];
const initialCountries = dropCountries.map((code) =>
  allCountries.find((c) => c.code === code)
);

const Careers = () => {
  const headerVariants = {
    hidden: { opacity: 0, y: -30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <div className="positionsSection">
      <motion.div
        className="positionsWrap"
        initial="hidden"
        animate="visible"
        variants={headerVariants}
      >
        <motion.div className="positionsContent" variants={headerVariants}>
          <h1>
            Open <span>Positions</span>
          </h1>
          <p>Some open positions for softations that you can apply on</p>
        </motion.div>
        
        <div className="positionsRightColumn">
          {Positions.map((position) => (
            <PositionItem 
              key={position.id} 
              position={position} 
              allCountries={allCountries}
              initialCountries={initialCountries}
            />
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default Careers;